<div
  class="container-fluid p-0 content-wrapper"
  [ngClass]="{ mobile: isMobileLayout }"
>
  <div class="mb-3 px-4">
    <h2>{{ title | msg | async }}</h2>
  </div>
  <div
    class="container-fluid animated fadeIn h-100 overflow-auto custom-scroll content-wrapper-content"
  >
    <div class="row">
      <ng-content> </ng-content>
    </div>
  </div>
</div>
